var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PaxWidget',{attrs:{"paxObject":_vm.params.paxObject,"minPax":_vm.params.minPax,"maxPax":_vm.params.maxPax,"kalkPax":_vm.params.kalkPax,"forecastPax":_vm.params.forecastPax,"durchfuehrbareMinPax":_vm.params.durchfuehrbareMinPax,"id":_vm.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }